import React, { useEffect, useMemo, useState, useImperativeHandle } from 'react';
import { Button } from 'antd';
import { OrderedListOutlined } from '@ant-design/icons';
import { ReorderableTable } from '../../../../components/reorderableTable/ReorderableTable';
import useBrands from '../../../gql/hooks/useBrands'; 
import useSearch from '../../../gql/hooks/useSearch'; 
import useHasError from '../../../hooks/useHasError'; 
import useIsLoading from '../../../hooks/useIsLoading'; 
import Spinner from '../../../components/Spinner/Spinner';
import './styles.less';

const CategoriesReorder = ( { saving, ref } ) => {
    const [ tableData, setTableData ] = useState( [] );
    const [ updatedKeys, setUpdatedKeys ] = useState();
    const [ selectedBrandId, setSelectedBrandId ] = useState();

    const { brandsLoading, brandsError, brands } = useBrands();
    const { searchData, loadSearch, searchLoading, searchError } = useSearch( { type: 'categories' } );
    
    const { isLoading } = useIsLoading( { items: [ brandsLoading, searchLoading ] } );
    const { hasError } = useHasError( { items: [ brandsError, searchError ] } );

    useEffect( () => loadSearch( { limit: 10000 } ), [] );
    
    useEffect( () => {
        setTableData( searchData.sort( ( a, b ) => 
            a.sortOrder === null ? 1 : 
                b.sortOrder === null ? -1 : a.sortOrder - b.sortOrder ) );
    }, [ searchData ] );
    
    const filteredTableData = useMemo( () => {
        if ( selectedBrandId ) {
            return tableData.filter( i => i.brandId === selectedBrandId );
        } else {
            return tableData;
        }
    }, [ tableData, selectedBrandId ] );

    useImperativeHandle( ref, () => ( {
        getUpdatedKeys: () => {
            return updatedKeys;
        },
        getSelectedBrandId: () => {
            return selectedBrandId;
        }
    } ) );

    const handleOnReorder = async ( sortedKeys ) => { 
        setUpdatedKeys( sortedKeys );
    };

    const handleSelectBrand = ( id ) => {
        setSelectedBrandId( id );
    };

    return (
        <div className="search-reorder">

            { isLoading && 
                <Spinner/>
            }
            
            { saving &&
                <Spinner/>
            }
            
            { ( !isLoading && !hasError && !selectedBrandId ) && 
                <>
                    <p><strong>Please select a brand to reorder</strong></p>
                    {
                        brands.map( i =>  (
                            <Button 
                                block 
                                key={ i.id }
                                value={ i.id }
                                style={ { marginBottom: '10px' } }
                                onClick={ () => handleSelectBrand( i.id ) }
                            >
                                { i.name }
                            </Button>
                        )
                        )
                    }
                </>
            }
            
            { ( !isLoading && !hasError && !saving && selectedBrandId ) &&
                <ReorderableTable 
                    pagination={ false }
                    reorderable={ true }
                    dataSource={ filteredTableData }
                    size="small"
                    showHeader={ true }
                    onReorder= { handleOnReorder }
                    columns={ [
                        {
                            dataIndex: 'sortOrder',
                            key: 'sortOrder', 
                            title: 'Sort Order', 
                            render: ( sortOrder, object, index ) => 
                                <div className="reorder-row">
                                    <OrderedListOutlined />    
                                    <span style={ { marginLeft: '10px' } }>{ index + 1 }</span>
                                </div>
                        },
                        {
                            dataIndex: 'name',
                            key: 'name', 
                            title: 'Name',
                            render: ( name ) => <span>{ name }</span>     
                        }
                    ] }                        
                />
            }
        </div>
    );
};

export default CategoriesReorder;
